module.exports = __webpack_public_path__ + "img/oatesa.673c7d15.jpg";